import React from 'react'
import useStyles from './styles'

import { Copy } from 'iconsax-react'
import { useAppDispatch } from '@SonarCX/hooks/redux'
import { AddErrorAlert, AddSuccessAlert } from '@SonarCX/slices/alert'

const successMessage = 'Successfully copied to clipboard'

const Instructions = ({ id }) => {
  const dispatch = useAppDispatch()
  const classes = useStyles()
  const script = `<script src="${
    import.meta.env.REACT_APP_WIDGET_URI
  }/install.js" data.key="${id}"></script>`
  const openWidgetCode = `window.SONAR_CX.openWidget()`
  const openWidgetBtnCode = `<button onclick="contactUs()">Contact Us</button>`
  const openWidgetBtnScripCode = ` <script>
  function contactUs(){
   window.SONAR_CX.openWidget()
  }
</script>`

  const copyToClipboard = React.useCallback(
    text => {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          dispatch(AddSuccessAlert(successMessage))
        })
        .catch(err => {
          console.error('Copying failed', err)
          dispatch(AddErrorAlert(err))
        })
    },
    [dispatch]
  )

  return (
    <div className={classes.root}>
      <div style={{ padding: '1rem' }}>
        Copy and paste this snippet and place at the end of the body tag of your
        html file
      </div>
      <div className={classes.codeBlock}>
        <div>
          <code id='codeSnippet'>{script}</code>
        </div>
        <div className={classes.copyButton}>
          <Copy variant='Bulk' onClick={() => copyToClipboard(script)} />
        </div>
      </div>

      <div style={{ padding: '1rem' }}>
        Copy and paste this snippet on your event of choice to activate the
        widget remotely on the website.
      </div>
      <div className={classes.codeBlock}>
        <div>
          <code id='openWidgetCodeSnippet'>{openWidgetCode}</code>
        </div>
        <div className={classes.copyButton}>
          <Copy
            variant='Bulk'
            onClick={() => copyToClipboard(openWidgetCode)}
          />
        </div>
      </div>

      <div style={{ padding: '1rem' }}>Example</div>
      <div className={classes.codeBlock}>
        <div>
          <code>{openWidgetBtnCode}</code>
          <br />
          <code>{openWidgetBtnScripCode}</code>
        </div>
      </div>
    </div>
  )
}

export default Instructions
